<template>
  <div class="machine-learning-stat">
    <a-row type="flex" :gutter="10" class="filters">
      <a-col>
        <tabs v-model="currentType" :tabs="typeTitles">
          <div :key="types.TYPE_DIAGRAM"></div>
        </tabs>
      </a-col>
      <a-col flex="1">
        <input-enum
          v-model="category" style="height: 40px" :options="categories"
          :allowClear="false"
          @search="categorySearch"
        />
      </a-col>
      <a-col flex="1">
        <input-enum
          v-model="region" style="height: 40px" :options="regions"
          :allowClear="false"
        />
      </a-col>
    </a-row>

    <div v-if="currentType === 'Диаграмма'">
      <div class="block-wrapper">
        <v-chart class="chart" :option="processedChecksChartOptions" />
      </div>

      <a-row type="flex" :gutter="10" class="filters">
        <a-col flex="1">
          <input-enum
            v-model="category" style="height: 40px" :options="categories"
            :allowClear="false"
            @search="categorySearch"
          />
        </a-col>
        <a-col flex="1">
          <input-enum
            v-model="version"
            label="Версия:" style="height: 40px; min-width: 150px;" :options="versions"
            :allowClear="false"
          />
        </a-col>
      </a-row>

      <a-row type="flex" :gutter="30" style="margin-top: 10px">
        <a-col flex="1">
          <div class="block-wrapper">
            <h3>Точность модели</h3>

            <v-chart class="chart" :option="modelAccuracyChartOptions" />
          </div>
        </a-col>
        <a-col flex="1">
          <div class="block-wrapper">
            <h3>Потери</h3>
            <v-chart class="chart" :option="modelLossChartOptions" />
          </div>
        </a-col>
      </a-row>
    </div>
    <div v-else>
      <div class="block-wrapper">
        <the-table
          :headerHeight="0"
          :config="tableHeader"
          :defaultSort="[]"
          :data="tableData"
          :canHideColumns="false"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { PieChart, LineChart } from 'echarts/charts';
import { TooltipComponent, LegendComponent, GridComponent } from 'echarts/components';
import VChart from 'vue-echarts';
import Tabs from '@/components/base/Tabs.vue';
import TheTable from '../../pages/table/table/TheTable';
import inputEnum from "@/components/base/InputEnum";
import {apolloClient} from "@/apolloClient";
import TABLE_QUERY from "@/queries/table";
import {bus, storage} from "@/helpers";

const apiUrl = process.env.VUE_APP_ROSSTAT_API_URL;

use([CanvasRenderer, LineChart, PieChart, TooltipComponent, LegendComponent, GridComponent]);

const types = Object.freeze({
  TYPE_DIAGRAM: 'Диаграмма',
  TYPE_TABLE: 'Таблица',
});

export default {
  name: 'MachineLearningStat',
  components: {
    TheTable,
    Tabs,
    VChart,
    inputEnum
  },

  data: () => ({
    types,
    date: '',
    categories: [],
    category_search: '',
    category: '',
    versions: [],
    version: '',
    regions: [],
    region: '',
    currentType: types.TYPE_DIAGRAM,

    processedChecksChartOptions: {
      tooltip: {
        trigger: 'item',
        formatter: '{b} : {c} ({d}%)',
      },
      legend: {
        orient: 'vertical',
        right: 'center',
        top: 'center',
        data: ['Верно', 'Не верно', 'Затрудняюсь ответить'],
      },
      series: [
        {
          type: 'pie',
          radius: ['50%', '80%'],
          center: ['17%', '50%'],
          data: [
            { value: 550, name: 'Верно' },
            { value: 330, name: 'Не верно' },
            { value: 220, name: 'Затрудняюсь ответить' },
          ],
          labelLine: {
            show: false,
          },
          label: {
            show: false,
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)',
            },
          },
        },
      ],
    },

    modelAccuracyChartOptions: { },

    modelLossChartOptions: {},

    tableHeader: {
      displayFields: [
        {
          label: 'Название',
          field: 'Название',
          index: 'Название',
          name: 'Название',
          width: 500,
        },
        {
          label: 'Значение',
          field: 'Значение',
          index: 'Значение',
          name: 'Значение',
        },
      ],
    },
    tableData: {
      rows: [
        { Название: 'Верно', Значение: '550 (50%)' },
        { Название: 'Неверно', Значение: '330 (30%)' },
        { Название: 'Затрудняюсь ответить', Значение: '220 (20%)' },
      ],
    },
  }),
  computed: {
    typeTitles() {
      return [types.TYPE_DIAGRAM, types.TYPE_TABLE];
    },
  },
  watch: {
    category(){
      this.get_versions()
      this.get_statistic_ml()
      this.refetch()
    },
    version(){
      this.refetch()
    },
    region(){
      this.get_statistic_ml()
    }
  },
  mounted(){
    this.get_categories()
    this.get_regions()
  },
  methods: {
    async get_statistic_ml() {
      await this.axios
        .get(`${apiUrl}/report/get_statistic_ml?region=${this.region_code_arr[this.region]}&category=${this.category}`,
          {
            // headers: {
            //   'finch-auth': `Bearer ${storage.get('authToken')}`
            // }
          })
        .then(({data}) => {
          const dict = {
            'unknown_count': 'Затрудняюсь ответить',
            'class_error_count': 'Не верно',
            'valid_count': 'Верно',
          }
          this.tableData.rows = Object.keys(data)
            .filter((el)=>el!=='sum')
            .map((key) => ({
              'Название': dict[key],
              'Значение': `${data[key]} (${Math.round(data[key] * 100 / data.sum)}%)`
            }))
          this.processedChecksChartOptions = {
            tooltip: {
              trigger: 'item',
              formatter: '{b} : {c} ({d}%)',
            },
            legend: {
              orient: 'vertical',
              right: 'center',
              top: 'center',
              data: ['Верно', 'Не верно', 'Затрудняюсь ответить'],
            },
            series: [
              {
                type: 'pie',
                radius: ['50%', '80%'],
                center: ['17%', '50%'],
                data: Object.keys(data)
                  .filter((el) => el !== 'sum')
                  .map((key) => ({
                    'name': dict[key],
                    'value': `${data[key]}`
                  })),
                labelLine: {
                  show: false,
                },
                label: {
                  show: false,
                },
                emphasis: {
                  itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)',
                  },
                },
              },
            ],
          }
        })
        .catch((error) => {
          throw error
        })
    },
    async get_regions() {
      const prevRegion = this.region;
      const client = apolloClient
        .query({
          ...TABLE_QUERY,
          variables: {
            type: 'Region',
            page: 0,
            pageSize: 10000,
          },
        })
        .catch((error) => {
          bus.$emit('error', {
            from: 'configFormLayout',
            description: `Ошибка получения конфига таблицы FNSClassesConfiguration`,
          });
          throw error;
        });
      client.then((res) => {
        const arr = [];
        res.data.table.documents.forEach(({ data }) => {
          arr[data.name_region] = data.okato;
        });
        this.regions = Object.keys(arr);
        if (!this.regions.includes(prevRegion)) {
          this.region = this.regions[0];
          this.region = 'Москва';
        }
        this.region_code_arr = arr;
      });
    },

    categorySearch(value) {
      this.category_search = value
      this.get_categories()
    },
    async get_categories() {
      const prevCategory = this.category;
      const client = apolloClient
        .query({
          ...TABLE_QUERY,
          variables: {
            type: 'FNSClassesConfiguration',
            page: 0,
            pageSize: 999,
            filters: [
              {
                field: "name",
                value: this.category_search,
                operator: "ILIKE"
              }
            ],
          },
        })
        .catch((error) => {
          throw error;
        });
      client.then((res) => {
        let arr = [];
        let response = res.data.table.documents.map(({ data }) => data.name);
        const favorites = ['Картофель', "Морковь", 'Сметана'];
        this.categories = favorites.concat(response.sort().filter(el => !(favorites.includes(el))));
        if (!this.categories.includes(prevCategory)) {
          this.category = this.categories[0];
        }
      });
      this.category_search = ''
      this.get_versions()
    },
    async get_versions() {
      await this.axios
        .get(`${apiUrl}/worker/ml_version?category_name=${this.category}`, {
            // headers: {
            //   'finch-auth': `Bearer ${storage.get('authToken')}`
            // }
          })
        .then(({data}) => {
          this.versions = data.map(Number).sort(function (a, b) {
            return a - b;
          }).map(String);
          this.version = this.versions[0]
        })
        .catch((error)=>{
          this.$notification.error({
            message: `Не удалось получить список версий. Обратитесь к администратору.`,
          });
          throw error
        })
    },
    async refetch(){
      this.modelAccuracyChartOptions = {
        xAxis: {
          type: 'category',
        },
        yAxis: {},
        series: [
          {
            data: [],
            type: 'line',
            smooth: true,
          },
        ],
      }
      this.modelLossChartOptions = {
        xAxis: {
          type: 'category',
        },
        yAxis: {},
        series: [
          {
            data: [],
            type: 'line',
            smooth: true,
          },
        ],
      }
      if (!this.category || !this.version) {
        return null
      }
      await this.axios
        .get(`${apiUrl}/report/get_history_version?category=${this.category}&version=${this.version}`,
          {
            // headers: {
            //   'finch-auth': `Bearer ${storage.get('authToken')}`
            // }
          })
        .then(({data}) => {
          this.modelAccuracyChartOptions = {
            xAxis: {
              type: 'category',
            },
            yAxis: {},
            series: [
              {
                data: data.acc,
                type: 'line',
                smooth: true,
              },
            ],
          }
          this.modelLossChartOptions = {
            xAxis: {
              type: 'category',
            },
            yAxis: {},
            series: [
              {
                data: data.loss,
                type: 'line',
                smooth: true,
              },
            ],
          }
        })
        .catch((error)=>{
          this.$notification.error({
            message: `Не удалось получить данные. Обратитесь к администратору.`,
          });
          throw error
        })
    }
  }
};
</script>

<style lang="scss">
.machine-learning-stat {
  .chart {
    height: 300px;
  }
}
</style>
